import { buildDefaultPermissions } from './model';
import type {
  PermissionsCreateSchema,
  PermissionsFormSchema,
  PermissionsQuerySchema,
  UserRoleFormSchema,
  UserRoleQuerySchema,
} from './schemas';

export function permissionsQueryToForm(
  permissions: UserRoleQuerySchema['permissions'],
  defaultPermissions = buildDefaultPermissions()
): UserRoleFormSchema['permissions'] {
  return defaultPermissions.map((defaultPermission) => {
    const matchingPermission = permissions.find(
      (permission) =>
        permission.resource === defaultPermission.resource &&
        permission.resource_type === defaultPermission.resource_type &&
        permission.action === defaultPermission.action
    );

    return {
      ...defaultPermission,
      ...matchingPermission,
      value: !!matchingPermission?.action,
    };
  });
}

export function permissionsFormToCreate(
  permissions: UserRoleFormSchema['permissions'],
  roleId: number
): PermissionsCreateSchema[] {
  // !important keep this code for debugging

  // const x = permissions.map((item) => ({
  //   ...item,
  //   action: item.action,
  //   resource: item.resource,
  //   resource_type: item.resource_type,
  // }));

  // console.log('permissionsFormToCreate', x);

  return permissions
    .filter((item) => item.value)
    .map((permission) => ({
      action: permission.action,
      resource: permission.resource,
      resource_type: permission.resource_type,
      role_id: roleId,
    }));
}

export function permissionsFormToUpdate(permissions: (PermissionsQuerySchema | PermissionsFormSchema)[]): number[] {
  return permissions.map((permission) => permission.id);
}
